import { RouteBuilder } from '@lib/utils/routeBuilder';
import {
  DEFAULT_LIST_PARAMS,
  PATH_AUTH,
  PATH_DASHBOARD,
  PATH_ERROR,
  PATH_SETUP,
} from '@lib/enums/urls';

export const SYSTEM_APP_URLS = {
  root: new RouteBuilder({
    path: '/',
  }),
  auth: {
    index: new RouteBuilder({
      path: `/${PATH_AUTH}`,
    }),
    login: new RouteBuilder({
      path: `/${PATH_AUTH}/login`,
    }),
    forgotPassword: new RouteBuilder({
      path: `/${PATH_AUTH}/forgot-password`,
    }),
    resetPassword: new RouteBuilder({
      path: `/${PATH_AUTH}/reset-password`,
    }),
    logout: new RouteBuilder({
      path: `/${PATH_AUTH}/logout`,
    }),
    verify2FA: new RouteBuilder({
      path: `/${PATH_AUTH}/verify-2fa`,
    }),
    accountLocked: new RouteBuilder({
      path: `/${PATH_AUTH}/account-locked`,
    }),
    accountSecured: new RouteBuilder({
      path: `/${PATH_AUTH}/account-secured`,
    }),
    lockAccount: new RouteBuilder({
      path: `/${PATH_AUTH}/lock-account`,
    }),
    restoreAccount: new RouteBuilder({
      path: `/${PATH_AUTH}/restore-account`,
    }),
  },
  setup: {
    index: new RouteBuilder({
      path: `/${PATH_SETUP}`,
    }),
    finishRegistration: new RouteBuilder({
      path: `/${PATH_SETUP}/finish-registration`,
    }),
    confirmEmail: new RouteBuilder({
      path: `/${PATH_SETUP}/confirm-email`,
    }),
    updatePassword: new RouteBuilder({
      path: `/${PATH_SETUP}/update-password`,
    }),
    update2FA: new RouteBuilder({
      path: `/${PATH_SETUP}/update-2fa`,
    }),
  },
  dashboard: {
    index: new RouteBuilder({
      path: `/${PATH_DASHBOARD}`,
    }),
    companies: {
      index: new RouteBuilder({
        path: `/${PATH_DASHBOARD}/accounts`,
        defaultParams: { ...DEFAULT_LIST_PARAMS },
      }),
      add: new RouteBuilder({
        path: `/${PATH_DASHBOARD}/accounts/add`,
      }),
      edit: new RouteBuilder({
        path: `/${PATH_DASHBOARD}/accounts/:id/edit`,
      }),
      view: new RouteBuilder({
        path: `/${PATH_DASHBOARD}/accounts/:id/view`,
      }),
    },
    industries: {
      index: new RouteBuilder({
        path: `/${PATH_DASHBOARD}/industries`,
        defaultParams: { ...DEFAULT_LIST_PARAMS },
      }),
    },
    systemAdmins: {
      index: new RouteBuilder({
        path: `/${PATH_DASHBOARD}/system-admins`,
        defaultParams: { ...DEFAULT_LIST_PARAMS },
      }),
    },
    technicalPauses: {
      index: new RouteBuilder({
        path: `/${PATH_DASHBOARD}/technical-pauses`,
        defaultParams: { ...DEFAULT_LIST_PARAMS },
      }),
    },
    profile: new RouteBuilder({
      path: `/${PATH_DASHBOARD}/profile`,
    }),
    sessions: new RouteBuilder({
      path: `/${PATH_DASHBOARD}/sessions`,
    }),
  },
  notFound: new RouteBuilder({
    path: '/not-found',
  }),
  error: new RouteBuilder({
    path: `/${PATH_ERROR}`,
  }),
};
